import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  FileText,
  Receipt,
  CreditCard,
  Users,
  TrendingUp,
  Settings,
  MessageSquare,
  Bot,
  User,
  ChevronLeft,
  ChevronRight,
  Home
} from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

export const Sidebar: React.FC = () => {
  const { user } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  console.log('Sidebar rendering - User role:', user?.role);

  const adminNavItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
    { icon: FileText, label: 'Invoices', path: '/invoices' },
    { icon: Receipt, label: 'Quotes', path: '/quotes' },
    { icon: TrendingUp, label: 'Expenses', path: '/expenses' },
    { icon: CreditCard, label: 'Payments', path: '/payments' },
    { icon: Users, label: 'Clients', path: '/clients' },
    { icon: Bot, label: 'AI Assistant', path: '/ai-assistant' },
    { icon: Settings, label: 'Settings', path: '/settings' },
  ];

  const clientNavItems = [
    { icon: Home, label: 'Overview', path: '/client-portal' },
    { icon: FileText, label: 'Invoices', path: '/client-portal/invoices' },
    { icon: Receipt, label: 'Quotes', path: '/client-portal/quotes' },
    { icon: CreditCard, label: 'Payments', path: '/client-portal/payments' },
    { icon: MessageSquare, label: 'Support', path: '/client-portal/support' },
    { icon: Bot, label: 'AI Assistant', path: '/client-portal/ai-assistant' },
  ];

  const navItems = user?.role === 'admin' ? adminNavItems : clientNavItems;

  return (
    <div className={`bg-white border-r border-gray-200 ${collapsed ? 'w-20' : 'w-64'} min-h-screen flex flex-col transition-all duration-300 relative`}>
      <div className="p-6 border-b border-gray-200 flex items-center justify-between">
        <div className={`flex items-center ${collapsed ? 'justify-center w-full' : 'space-x-3'}`}>
          <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center">
            <Bot className="w-6 h-6 text-white" />
          </div>
          {!collapsed && (
            <div>
              <h1 className="text-xl font-bold text-gray-900">AI CRM</h1>
              <p className="text-sm text-gray-500">Smart Business Hub</p>
            </div>
          )}
        </div>
        <button 
          onClick={() => setCollapsed(!collapsed)}
          className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
        >
          {collapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
        </button>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center ${collapsed ? 'justify-center' : 'space-x-3'} px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
            title={collapsed ? item.label : undefined}
          >
            <item.icon size={20} />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-200">
        <div className={`flex items-center ${collapsed ? 'justify-center' : 'space-x-3'} px-4 py-3`}>
          <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
            <User size={16} className="text-gray-600" />
          </div>
          {!collapsed && (
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900 truncate">{user?.full_name || 'User'}</p>
              <p className="text-xs text-gray-500 capitalize">{user?.role || 'User'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};